import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from '@/locales';

const dummyHistory = [
    // { id: 1, question: "什么显卡性价比高？", time: "今天 10:21" },
    // { id: 2, question: "《红楼梦》最打动你的情节？", time: "昨天 22:03" },
    // { id: 3, question: "AI如何帮助科研？", time: "6月21日 14:10" },
];

export default function HistoryPage() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <main className="pl-20 pr-6 py-12 min-h-screen bg-background">
            <div className="max-w-3xl mx-auto space-y-4">
                <h2 className="text-xl font-semibold">{t('history.questionHistory')}</h2>
                {dummyHistory.map((item) => (
                    <Card
                        key={item.id}
                        className="cursor-pointer transition hover:bg-muted rounded-lg border border-border"
                        onClick={() => navigate(`/detail?id=${item.id}`)}
                    >
                        <CardContent className="p-4 flex flex-col gap-1">
              <span className="text-base text-foreground font-medium">
                {item.question}
              </span>
                            <span className="text-xs text-muted-foreground">{item.time}</span>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </main>
    );
}
